var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "verified_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M23,11.99,20.56,9.2l.34-3.69-3.61-.82L15.4,1.5,12,2.96,8.6,1.5,6.71,4.69,3.1,5.5l.34,3.7L1,11.99l2.44,2.79-.34,3.7,3.61.82L8.6,22.5,12,21.03l3.4,1.46,1.89-3.19,3.61-.82-.34-3.69Zm-3.95,1.48-.56.65.08.85.18,1.95-1.9.43-.84.19-.44.74-.99,1.68-1.78-.77-.8-.34-.79.34-1.78.77-.99-1.67L8,17.55l-.84-.19-1.9-.43.18-1.96.08-.85-.56-.65L3.67,12l1.29-1.48.56-.65-.09-.86L5.25,7.07l1.9-.43.84-.19.44-.74.99-1.68,1.78.77.8.34.79-.34,1.78-.77.99,1.68.44.74.84.19,1.9.43-.18,1.95-.08.85.56.65,1.29,1.47Z",
    fill: "#2f68fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M10.09,13.75,7.77,11.42,6.29,12.91l3.8,3.81,7.34-7.36L15.95,7.87Z",
    fill: "#2f68fa"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateCompleted);
export default __webpack_public_path__ + "static/media/update_completed.11318cd1f0d0cf339bf603b06df6bb72.svg";
export { ForwardRef as ReactComponent };